import React from "react";
import PropTypes from "prop-types";
// import unitmap from 'https://cdn.unitmap.com/sdk/js/0.9.0/unitmap.js';
export const MapContext = React.createContext({
  map: null,
  units: null,
  levels: null
});

export default class UnitMap extends React.Component {
  constructor(props) {
    super(props);

    this.elementRef = React.createRef();

    this.state = {
      map: null,
      units: null,
      levels: null
    };
  }

  componentDidMount() {
    // `unitmap` is the global injected by the UnitMap SDK.
    // eslint-disable-next-line no-undef
    let map = unitmap(this.elementRef.current, this.props.apiKey);
    map.load(this.props.id, () => {
      this.setState({
        map: map,
        units: map.units(),
        levels: map.levels()
      });
    });
  }

  render() {
    return (
      <div
        ref={this.elementRef}
        style={{
          width: this.props.width,
          height: this.props.height
        }}
      >
        <MapContext.Provider value={this.state}>
          {this.props.children}
        </MapContext.Provider>
      </div>
    );
  }
}

UnitMap.defaultProps = {
  height: "100%"
};

UnitMap.propTypes = {
  id: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundImage: PropTypes.string
};
